import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { CreateAccountParams, CreateAccountResult } from '@se-po/shared-data-access-models'
import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root'
})
export class UserCreateService {

  constructor(
    private api: UserServiceApiService,
  ) { }

  public create(params: CreateAccountParams): Observable<CreateAccountResult> {
    const url = 'users.json'

    return this.api.post<CreateAccountResult>(url, params)
      .pipe(first(), map(r => r?.result))
  }
}
